/**
 * Raport wydatkow (zakładka "Wydatki" w module księgowym) - usługa API.
 *
 * Backend: api/raport_wydatkow.py (uprawnienie raporty.finansowe, heavy_limit).
 *   GET /raporty/wydatki?od&do&location_id&grupuj=miesiac|sklep|kategoria
 *                        &klucz_ogolnych=centrala|rowno|obrot&ujecie=memorial|kasa
 *     -> {grupy, razem, platnosci, udzial_ksef, meta: {kategorie, uwagi, ...}}
 *   GET /raporty/wydatki/eksport.csv?(te same parametry) -> plik CSV
 * Odpowiedzi idą przez success_response {success, data} - funkcje zwracają odpakowane `data`.
 */
import { apiLong } from './api';

const odpakuj = (response) => response?.data?.data ?? response?.data;

/** Usuwa puste parametry, żeby nie wysyłać location_id= (backend traktuje '' jak brak, ale URL jest czystszy). */
export const czysteParametry = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined)
);

export const raportWydatkowService = {
  async pobierz(params = {}) {
    const response = await apiLong.get('/raporty/wydatki', { params: czysteParametry(params) });
    return odpakuj(response);
  },

  /** Pobiera CSV i uruchamia zapis pliku w przeglądarce. Zwraca nazwę pliku. */
  async eksportCsv(params = {}) {
    const response = await apiLong.get('/raporty/wydatki/eksport.csv', {
      params: czysteParametry(params),
      responseType: 'blob',
    });
    const dyspozycja = response?.headers?.['content-disposition'] || '';
    const m = dyspozycja.match(/filename="?([^";]+)"?/);
    const nazwa = m ? m[1] : `wydatki_${params.od || ''}_${params.do || ''}.csv`;
    const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: 'text/csv;charset=utf-8' });
    if (typeof URL.createObjectURL === 'function') {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nazwa;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    }
    return nazwa;
  },
};

export default raportWydatkowService;
